import React from "react";
import {
  HashRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import RealTimeLineActivity from "./screens/reports/RealTimeLineActivity"; // Correctly capitalize the component name
import RealTimeWarehouseActivity from "./screens/reports/RealTimeWarehouseActivity";
import DrierStatusReport from "./screens/reports/DrierStatusReport";
import MenuScreen from "./screens/MenuScreen";
import WarehouseStatus from "./screens/reports/WarehouseStatus";

import LoginScreen from "./screens/LoginScreen";
import ScreenReports from "./components/ScreenReports";
import VehicleInformationReport from "./screens/reports/VehicleInformationReport";
import StockPositionReport from "./screens/reports/StockPositionReport";
import StockPositionNonSeed from "./screens/reports/StockPositionNonSeed";
import ExternalImagesReport from "./screens/reports/ExternalImagesReport";
import OpenbravoLogViewer from "./screens/OpenbravoLog";
import TimeLineReport from "./screens/BinReport/TimeLineReport";
import BinBatches from "./screens/BinReport/BinBatches";
if (window.location.pathname !== "/" && !window.location.hash) {
  window.location.replace(`/#${window.location.pathname}`);
}

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Default redirect to Login page */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        {/* Add Login route */}
        <Route path="/login" element={<LoginScreen />} />
        {/* Other routes */}
        <Route path="/menu" element={<MenuScreen />} />
        <Route path="/log" element={<OpenbravoLogViewer />} />
        <Route path="/screenreports" element={<ScreenReports />} />
        <Route
          path="/real-time-line-activity"
          element={<RealTimeLineActivity />}
        />
        <Route
          path="/real-time-warehouse-activity"
          element={<RealTimeWarehouseActivity />}
        />
        <Route
          path="/vehicle-information-report"
          element={<VehicleInformationReport />}
        />
        <Route path="/driar-status-report" element={<DrierStatusReport />} />
        <Route path="/warehouse-status-report" element={<WarehouseStatus />} />
        <Route
          path="/stock-position-report"
          element={<StockPositionReport />}
        />
        <Route
          path="/stock-position-non-seed"
          element={<StockPositionNonSeed />}
        />
        <Route
          path="/external-images-report"
          element={<ExternalImagesReport />}
        />
        <Route path="/TimeLineReport" element={<TimeLineReport />} />
             <Route path="/BinBatches" element={<BinBatches />} />

        <Route path="/*" element={<h1>Report Not Found</h1>} />{" "}
        {/* Fallback Route */}
      </Routes>
    </Router>
  );
};

export default App;
